// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
    background-color: #fff;
    padding: 2rem 1.5rem;
    box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 50px;
}

.form label {
    margin-bottom: 5px;
}

.inputField {
    display: block;
    width: 100%;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #A7A29E;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    margin-bottom: 20px;
}

.form-control-file {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 0.75rem;
    border-radius: 0.375rem;
    border-width: 1px;
    width: 100%;
    height: 2.5rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #9CA3AF;
    transition: all .4s ease-in-out
}

.formButton {
    cursor: pointer;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    transition: all .4s ease-in-out;
    color: #fff;
    border-radius: 5px;
}

.formButton:hover {
    border-radius: 40px;
}

.formButton.submit {
    border: 1px solid #00BFB4;
    background-color: #00BFB4;
}`, "",{"version":3,"sources":["webpack://./src/css/CreateFacility.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,sEAAsE;IACtE,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B","sourcesContent":[".form {\n    background-color: #fff;\n    padding: 2rem 1.5rem;\n    box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);\n    border-radius: 5px;\n    padding: 10px;\n    margin-bottom: 50px;\n}\n\n.form label {\n    margin-bottom: 5px;\n}\n\n.inputField {\n    display: block;\n    width: 100%;\n    height: calc(2.25rem + 2px);\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #A7A29E;\n    border-radius: 0.25rem;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    margin-bottom: 20px;\n}\n\n.form-control-file {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    padding-right: 0.75rem;\n    border-radius: 0.375rem;\n    border-width: 1px;\n    width: 100%;\n    height: 2.5rem;\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n    color: #9CA3AF;\n    transition: all .4s ease-in-out\n}\n\n.formButton {\n    cursor: pointer;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    border: none;\n    transition: all .4s ease-in-out;\n    color: #fff;\n    border-radius: 5px;\n}\n\n.formButton:hover {\n    border-radius: 40px;\n}\n\n.formButton.submit {\n    border: 1px solid #00BFB4;\n    background-color: #00BFB4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
